import { GroupedBreakList, MissedBreakForAttestation } from './breakAttestationsModal.types';

export const shouldSkipOrdinals = (
  missedBreak: MissedBreakForAttestation,
  groupedBreakList: GroupedBreakList
) => {
  if (!groupedBreakList) return false;

  return groupedBreakList[missedBreak.type]?.length === 1;
};
